import type { ICampaignTemplate } from '~/modules/campaign-template';
import type { IBaseCampaignVersion } from '~/modules/campaign';

interface GetVersionsByCampaignGroupParams {
  campaignIds?: string[];
  campaignGroupId?: string;
  campaignGroupMap: Record<string, ICampaignTemplate>;
}

export function getVersionsByCampaignGroup({
  campaignIds,
  campaignGroupId,
  campaignGroupMap,
}: GetVersionsByCampaignGroupParams): IBaseCampaignVersion[] {
  if (!campaignGroupId) return [];

  const campaignGroup = campaignGroupMap[campaignGroupId];
  if (!campaignGroup?.versions) return [];

  if (!campaignIds || campaignIds.length === 0 || campaignIds.length > 1) {
    return campaignGroup.versions as IBaseCampaignVersion[];
  }

  const campaign = campaignGroup.campaigns?.find((item) => item.id === campaignIds[0]);
  if (!campaign?.versions) return [];

  return campaign?.versions as IBaseCampaignVersion[];
}
